import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading, checkSession } = useAuth();
  const location = useLocation();

  // Phase 44.31.3 — Fail-fast session check ad ogni cambio rotta.
  // Se la sessione è stata revocata server-side (cambio password, logout
  // globale, admin revoke da altro dispositivo), l'interceptor 401 in api.js
  // intercetterà la risposta e farà redirect immediato a /login?next=…
  // Throttled internamente a 3s per evitare raffiche su navigazioni rapide.
  useEffect(() => {
    if (user) checkSession?.();
  }, [location.pathname, user, checkSession]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-dapnow-bg">
        <div className="flex items-center gap-3 text-dapnow-muted">
          <div className="h-2.5 w-2.5 rounded-full bg-dapnow-blue animate-pulse" />
          <span className="text-sm">Caricamento…</span>
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  if (roles && roles.length > 0 && !roles.includes(user.role)) {
    if (user.role === "admin") return <Navigate to="/admin" replace />;
    if (user.role === "driver") return <Navigate to="/driver" replace />;
    return <Navigate to="/app" replace />;
  }

  return children;
}
